import SectionHeader from "./SectionHeader";
import { reactionCategories, reactionCategoriesMeta } from "@/pages/home/data/reactions";

const bubbleTones = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-800",
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
];

const barTones = [
  "bg-primary-500",
  "bg-accent-500",
  "bg-secondary-500",
  "bg-primary-400",
  "bg-accent-400",
];

export default function Reactions() {
  return (
    <section id="reactions" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeader
          eyebrow="反应分类"
          title={reactionCategoriesMeta.title}
          description={reactionCategoriesMeta.description}
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {reactionCategories.map((cat, i) => (
            <article
              key={cat.slug}
              className="group flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${bubbleTones[i % bubbleTones.length]}`}
                >
                  <i className={cat.icon} aria-hidden="true"></i>
                </span>
                <div className="text-right">
                  <span className="font-heading text-lg font-bold text-foreground-950">{cat.heat}</span>
                  <span className="text-[11px] text-foreground-500"> / 热度</span>
                </div>
              </div>

              <div className="mt-4 flex items-baseline gap-2">
                <h3 className="font-heading text-2xl font-bold text-foreground-950">{cat.label}</h3>
                <span className="text-xs uppercase tracking-wider text-foreground-500">{cat.en}</span>
              </div>

              {/* heat meter */}
              <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                <div
                  className={`h-full rounded-full ${barTones[i % barTones.length]}`}
                  style={{ width: `${cat.heat}%` }}
                ></div>
              </div>
              <p className="mt-2 text-xs text-foreground-600">{cat.trend}</p>

              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{cat.summary}</p>

              <div className="mt-4 flex flex-wrap gap-2">
                {cat.keywords.map((kw) => (
                  <span
                    key={kw}
                    className="whitespace-nowrap rounded-full bg-background-50 px-2.5 py-1 text-xs text-foreground-600"
                  >
                    {kw}
                  </span>
                ))}
              </div>

              <ul className="mt-4 space-y-1.5 border-t border-background-200 pt-3">
                {cat.points.map((p) => (
                  <li key={p} className="flex gap-2 text-[13px] leading-relaxed text-foreground-600">
                    <i
                      className="ri-checkbox-blank-circle-fill mt-1 h-1.5 w-1.5 shrink-0 text-xs text-primary-400"
                      aria-hidden="true"
                    ></i>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}

          {/* CTA card */}
          <a
            href="#analysis"
            className="group relative flex min-h-[260px] flex-col justify-between overflow-hidden rounded-xl bg-primary-500 p-5 text-background-50 transition-colors hover:bg-primary-600"
          >
            <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full bg-background-50/10"></div>
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs">
                <i className="ri-article-line" aria-hidden="true"></i>
                深度解读
              </span>
              <h3 className="mt-4 font-heading text-2xl font-bold leading-snug">
                看懂这些反应背后的心理，才算真正吃明白瓜
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-50/85">
                认知失调、沉没成本、回踩的补偿心理——编辑部把粉丝行为拆成可读的心理机制。
              </p>
            </div>
            <span className="mt-6 inline-flex items-center gap-1 text-sm font-medium">
              前往深度洞察
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}